// extracted by mini-css-extract-plugin
export default {"OutlookPill":"OutlookPill_OutlookPill__4MmB1","positive":"OutlookPill_positive__gL6c9","negative":"OutlookPill_negative__W-w2I","neutral":"OutlookPill_neutral__AlK2H"};